/*----------------------------------------------------------------------------
|
|    ShipToAddress
|
|    component to render ShipToAddress data of an order
|
|    May 2022
|
\---------------------------------------------------------------------------*/

import React from 'react';
import '../dataDictionary/dataDictionary.css';
import { SimpleDataGrid, BasicAlert, getCompleteURL } from '../common/components.jsx';
import { fmGrid } from '../common/formatter.jsx';

const minSearchChars = 2;

export class ShipToAddress extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            shipData: {},
            status: 'L',
            items_backup: {}
        }

        this.getShipToAddressData   = this.getShipToAddressData.bind(this);
        this.filter                 = this.filter.bind(this);
        this.handleSearchReset      = this.handleSearchReset.bind(this);
    }

    componentDidMount() {
        this.getShipToAddressData();
    }

    getShipToAddressData() {
        var items = this.props.order.items;
        var shipData = {};
        var area = "osv"

        if (this.props.caller && this.props.caller == "ext")
            area = "ext_widget"
        else if (this.props.caller && this.props.caller == "int")
            area = "int_widget"

        shipData =  {
                        header: [
                            { name: DD('item_subitem',   area) },
                            { name: DD('child_so_no',    area), nowrap:1 },
                            { name: DD('ship_to_addr_1', area) },
                            { name: DD('ship_to_addr_2', area) },
                            { name: DD('ship_to_addr_3', area) },
                            { name: DD('ship_to_addr_4', area) },
                            { name: DD('CountryName',    area) },
                            { name: DD('ship_to_city',   area, 'right') },
                            { name: DD('ship_to_attn',   area, 'right') },
                            { name: DD('ship_to_email',  area, 'right') },
                            { name: DD('ship_to_phone',  area, 'right') },
                            { name: DD('ship_to_fax',    area, 'right') },
                        ],
                        data: items.map(function(row) {
                                let url         =  "";
                                let f_url_field =  "";
                                if( row.child_so_no != "" && this.props.caller != "ext") {
                                    url = getCompleteURL({
                                                            lookupType  :"so_no",
                                                            lookupValue : row.child_so_no,
                                                            type        : this.props.caller
                                                        })
                                    f_url_field = <>{row.item_subitem}&nbsp;&nbsp;<a href={url} target="_blank"><i class='glyphicon glyphicon-new-window' title='click to open trade order having this item'></i></a> </>
                                } else {
                                    f_url_field = row.item_subitem
                                }

                                return [
                                            f_url_field,
                                            row.child_so_no,
                                            row.ship_to_addr_1,
                                            row.ship_to_addr_2,
                                            row.ship_to_addr_3,
                                            row.ship_to_addr_4,
                                            row.country,
                                            row.ship_to_city,
                                            row.ship_to_attn,
                                            row.ship_to_email,
                                            row.ship_to_phone,
                                            row.ship_to_fax
                                        ]
                        }.bind(this))
                    }
        this.setState({items_backup: shipData});
        this.setState({shipData: shipData});
        this.setState({status:'S'})
    }

    filter() {
        var searchText  = $("#textbox-zmso-shipto-search").val() || "";
        var backupList  = this.state.items_backup;
        // var updatedList = { header:{},data:{} };
        var updatedList = {};

        console.log("backupList is",backupList);
        if (searchText.length < minSearchChars ) {
            this.setState( { shipData: backupList } );
            return;
        }

        updatedList.header = backupList.header;
        updatedList.data = backupList.data.filter( function(item) {
            if (searchText.length >= minSearchChars) {
                return  item[8].toLowerCase().search(searchText.toLowerCase()) !== -1
            } else {
                return true;
            }
        });
            this.setState( { shipData: updatedList } );
    }

    handleSearchReset() {
        this.textboxSearch.value = "";
        this.filter();
    }

    render() {
        if (this.state.status == 'S') {

            var order = this.props.order;

            var leftLabel =
                this.state.shipData.data ?
                    <>
                        <span className="sdg-topbar-element">{this.state.shipData.data.length} rows</span>
                        <span style={{ "paddingLeft" : 40 }}>
                            <div className="btn-reset-x-container">
                                <input style={{width:'600px' , outline:'none' ,fontSize:"14px" , borderColor:'#e8e8e8' , height:28 }} id="textbox-zmso-shipto-search" type="text"
                                       placeholder={"Search item by Ship To Attention to Email (eg:my_name@domain.com) (Min. " + minSearchChars + " Chars)"}
                                       ref={(input)=> this.textboxSearch = input}
                                       onChange={this.filter} className="textbox-dd" />
                                <span onClick={this.handleSearchReset} className="btn-reset-x" style={{ "height" : 26 , "lineHeight": '27px' }}>X</span>
                            </div>
                        </span>
                    </>
              : "" ;
            // just hiding serach bar ,but it may require in future
            leftLabel = <span className="sdg-topbar-element">{this.state.shipData.data.length} rows</span>

            if(this.props.simpleWidget) {
                return(
                        <SimpleDataGrid enableDownload={true}
                                        downloadName={order.order_no+'_shipToAddress'}
                                        doUpdate={this.props.doUpdate} expandedByDefault={this.props.expandedByDefault}
                                        sortable={true}
                                        header={this.state.shipData.header}
                                        data={this.state.shipData.data} />
                        );
            } else {

                return (
                    <SimpleDataGrid enableDownload={true}
                                leftLabel={leftLabel}
                                height="400px" stretchTo="#globalFooter" stretchMargin="10"
                                downloadName={order.order_no+'_shipToAddress'}
                                sortable={true}
                                header={this.state.shipData.header}
                                data={this.state.shipData.data} />
                )
            }

        } else {
                return (
                    <BasicAlert type={this.state.status} />
                )
        }
    }
}
